import type { ProposalValidationResult } from "@repo/core/hooks/useProposalValidation";
import { PROPOSTA_SITUACAO } from "@repo/core/services/entities/Proposals";

const LOAD_DRAFT_ACTION = "LOAD_DRAFT";

export const INFO_SECURITY_FEEDBACK_TOASTS = {
  reanalysisCreated: {
    title: "Reanálise criada",
    message: "Continue para revisar os dados."
  },
  proposalLoaded: {
    title: "Proposta carregada",
    message: "Continue para revisar os dados."
  }
} as const;

interface InfoSecurityProcessingState {
  isSubmitting: boolean;
  isContinuePressed: boolean;
  isCreatingReanalysis: boolean;
  isSavingInfoSecurity: boolean;
  isValidatingCPF?: boolean;
  isKeepingCurrentPhone?: boolean;
}

export const resolveInfoSecurityProcessingState = ({
  isSubmitting,
  isContinuePressed,
  isCreatingReanalysis,
  isSavingInfoSecurity,
  isKeepingCurrentPhone
}: InfoSecurityProcessingState): boolean =>
  isSubmitting ||
  isContinuePressed ||
  isCreatingReanalysis ||
  isSavingInfoSecurity ||
  isKeepingCurrentPhone === true;

export const isDraftProposalStatus = (status?: string): boolean =>
  status === PROPOSTA_SITUACAO.DOCUMENT_CONFERENCE ||
  status === PROPOSTA_SITUACAO.DATA_CONFERENCE;

export const shouldNotifyProposalLoaded = (
  validationResult: Pick<ProposalValidationResult, "action" | "proposalDetails">
): boolean =>
  validationResult.action === LOAD_DRAFT_ACTION &&
  isDraftProposalStatus(validationResult.proposalDetails?.strSituacao);
